import "./About.scss";
import { HiChevronDoubleDown } from "react-icons/hi";
import { Link as Scroll } from "react-scroll";
import Banner from "../../components/Banner";

const AboutPage = () => {
  return (
    <>
      <section className="header-bg section">
        <div className="banner">
          <Banner />
        </div>
        <article className="header-bg__container">
          <div className="header-bg__container-contents">
            <h1 className="">ABOUT US </h1>
          </div>

          <Scroll
            to="next-section"
            smooth={true}
            duration={100}
            delay={0}
            offset={100}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="scroll-btn">
              <HiChevronDoubleDown />
              <span>Scroll Down</span>
            </div>
          </Scroll>
        </article>
      </section>

      <section className="section about" id="next-section">
        <article className="about__container container">
          <div className="about__container--contents">
            <div
              className="about__container--contents-about"
              data-aos="fade-down"
            >
              <h2>About TED</h2>
              <p>
                TED is a nonprofit organization devoted to Ideas Worth
                Spreading, often in the form of short talks delivered by leading
                thinkers and doers. Many of these talks are given at TED
                Conferences, intimate TED Salons and thousands of independently
                organised TEDx events around the world. Videos of these talks
                are made available, free, on{" "}
                <a href="http://ted.com/" target="_blank" rel="noreferrer">
                  TED.com
                </a>{" "}
                and other platforms. Audio versions of TED Talks are published
                to{" "}
                <a
                  href="http://applepodcasts.com/tedtalksdaily "
                  target="_blank"
                  rel="noreferrer"
                >
                  TED Talks Daily,
                </a>{" "}
                available on all podcast platforms. <br /> <br /> TED&apos;s
                open and free initiatives for spreading ideas include{" "}
                <a href="http://ted.com/" target="_blank" rel="noreferrer">
                  TED.com
                </a>
                , where new TED Talk videos are posted daily;{" "}
                <a
                  href="http://www.ted.com/tedx"
                  target="_blank"
                  rel="noreferrer"
                >
                  TEDx
                </a>
                , which licenses thousands of individuals and groups to host
                local, self-organized TED-style events around the world; the{" "}
                <a
                  href="http://www.ted.com/fellows"
                  target="_blank"
                  rel="noreferrer"
                >
                  TED Fellows
                </a>{" "}
                program, which selects innovators from around the globe to
                amplify the impact of their remarkable projects and activities;{" "}
                <a
                  href="https://audaciousproject.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  The Audacious Project
                </a>
                , which surfaces and funds critical ideas that have the
                potential to impact millions of lives;{" "}
                <a
                  href="https://www.ted.com/about/programs-initiatives/ted-translators"
                  target="_blank"
                  rel="noreferrer"
                >
                  TED Translators Program
                </a>
                , which crowdsources the subtitling of TED Talks so that big
                ideas can spread across languages and borders; and the
                educational initiative{" "}
                <a href="http://ed.ted.com/" target="_blank" rel="noreferrer">
                  TED-Ed
                </a>
                . TED also offers{" "}
                <a
                  href="https://tedatwork.ted.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  TED@Work
                </a>{" "}
                a program that reimagines TED Talks for workplace learning. TED
                also has a growing library of original podcasts, including The{" "}
                <a
                  href="https://www.ted.com/podcasts/ted-interview"
                  target="_blank"
                  rel="noreferrer"
                >
                  TED Interview
                </a>{" "}
                with Chris Anderson, WorkLife with Adam Grant, Far Flung with
                Saleem Reshamwala and{" "}
                <a
                  href="https://www.ted.com/podcasts/how-to-be-a-better-human"
                  target="_blank"
                  rel="noreferrer"
                >
                  How to Be a Better Human.
                </a>
                <br /> <br />
                Follow TED on{" "}
                <a
                  href="http://twitter.com/TEDTalks"
                  target="_blank"
                  rel="noreferrer"
                >
                  Twitter
                </a>
                ,{" "}
                <a
                  href="http://www.facebook.com/TED"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
                ,{" "}
                <a
                  href="https://instagram.com/ted"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
                , and on{" "}
                <a
                  href="https://www.linkedin.com/company/ted-conferences"
                  target="_blank"
                  rel="noreferrer"
                >
                  LinkedIn.
                </a>
              </p>
            </div>

            <div
              className="about__container--contents-about"
              data-aos="fade-down"
            >
              <h2>About TEDx, x = independently organized event</h2>
              <p>
                In the spirit of ideas worth spreading, TEDx is a program of
                local, self-organized events that bring people together to share
                a TED-like experience. At a TEDx event, TED Talks video and live
                speakers combine to spark deep discussion and connection. These
                local, self-organized events are branded TEDx, where x =
                independently organized TED event. The TED Conference provides
                general guidance for the TEDx program, but individual TEDx
                events are self-organized.
              </p>
            </div>

            <div
              className="about__container--contents-about"
              data-aos="fade-down"
            >
              <h2>About TEDxOAU</h2>
              <p>
                TEDxOAU is an independently organized TED event under an
                authorized license from TED at Obafemi Awolowo University,
                Ile-Ife. It is an initiative that aims to bring together a
                socially conscious community in OAU and involve young people in
                discussions about IDEAS WORTH SPREADING. Holding for the second
                time ever, and after a four-year hiatus—TEDxOAU targets an
                audience of students, young professionals, and academic members
                of staff. The conference hopes to shine the spotlight on
                interdisciplinary speakers — including those from the local
                community — who will ignite action, and encourage innovation and
                critical discussion.
                <br /> <br />
                Follow TEDxOAU on{" "}
                <a
                  href="http://Twitter.com/tedxoauofficial"
                  target="_blank"
                  rel="noreferrer"
                >
                  Twitter
                </a>
                ,{" "}
                <a
                  href="https://www.threads.net/@tedxoauofficial"
                  target="_blank"
                  rel="noreferrer"
                >
                  Threads
                </a>
                ,{" "}
                <a
                  href="http://Instagram.com/tedxoauofficial"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
                , and on{" "}
                <a
                  href="https://www.linkedin.com/company/tedxoauofficial/"
                  target="_blank"
                  rel="noreferrer"
                >
                  LinkedIn.
                </a>
              </p>
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default AboutPage;
